module.exports = __webpack_public_path__ + "fonts/jf-openhuninn-2.0.fd854b9.ttf";